"use client"

import React from "react"
import { useWindowDimensions } from "react-native"
import { FormattedMessage } from "react-intl"

import { Box, H2, Image, useIsSm } from "@bullseye/components"

const PotentialFriends = () => {
  const { width } = useWindowDimensions()
  const isSm = useIsSm()
  return (
    <Box className="flex items-center pt-20 g-10">
      <H2 className="max-w-[800px] px-4 text-center text-brand-indigo-1 md:px-0">
        <FormattedMessage id="home.friends.title" />
      </H2>
      <Box>
        <Image
          className="h-[500px] w-full md:h-[384px]"
          source={{
            uri: isSm
              ? "https://storage.googleapis.com/hank-app-assets/marketing/profile-bubbles-mobile.png"
              : "https://storage.googleapis.com/hank-app-assets/marketing/profile-bubbles-desktop.png",
          }}
          alt="Thousands of potential friends. One purpose: connection."
          resizeMode="cover"
          style={{
            width: width,
          }}
        />
      </Box>
    </Box>
  )
}

export default PotentialFriends
